import { Columns, Option } from '../../../shared/EditableTable/Model'
import React from "react";

export default function initialDataExpenditureMilestoneReport(options: Option<string>[]) {

    const toNumber = (anything: any) => {
        let tempNumber = Number(anything);
        return isNaN(tempNumber) ? 0 : tempNumber;
    }

  const columns: Columns[] = [
    {
      id: 'eligibleExpenditureCategoryCrmID',
      label: 'Eligible expense category',
      accessor: 'eligibleExpenditureCategoryCrmID',
      dataType: 'select',
      options,
      Footer: 'Total:',
      width:340
    },
    {
      id: 'totalEligibleExpenditure',
      label: 'Total eligible expenditure (AUD)',
      accessor: 'totalEligibleExpenditure',
      dataType: 'number',
        Footer: (  (info: { rows: number[]; } )=> {
        /*Footer: info => {*/
            const total = React.useMemo(
                () =>
                    info.rows.reduce((sum: number, row: any) => toNumber(row.values.totalEligibleExpenditure)  + sum, 0)
                ,[info.rows]
            ) 
            return <>{total.toFixed(2)}</>
        })
    },
    {
      id: 'grantSoughtAmount',
      label: 'Amount of grant sought (AUD)',
      accessor: 'grantSoughtAmount',
      dataType: 'number',
        Footer: ((info: { rows: number[]; }) => {
            const total = React.useMemo(
                () =>
                    info.rows.reduce((sum: number, row: any) => toNumber(row.values.grantSoughtAmount) + sum, 0)
                , [info.rows]
            )
            return <>{total.toFixed(2)}</>
        })
    },
    {
      id: 'granteeContributionAmount',
      label: 'Grantee\'s contribution amount (AUD)',
      accessor: 'granteeContributionAmount',
      dataType: 'number',
        Footer: ((info: { rows: number[]; }) => {
            const total = React.useMemo(
                () =>
                    info.rows.reduce((sum: number, row: any) => toNumber(row.values.granteeContributionAmount) + sum, 0)
                , [info.rows]
            )
            return <>{total.toFixed(2)}</>
        })
    },
    {
      id: 'remove',
      label: 'Remove',
      accessor: 'remove',
      dataType: 'remove',
      minWidth: 70,
      width: 70,
    },
  ]
  return { columns, skipReset: false }
}
